import { Article, ImageObject,WithContext } from "schema-dts";
import { organizationSchema } from "@shared/ui/SchemaJsonLd/config";
import { ArticleSchemaParams } from "./types";

export const getArticleSchema = ({
    articleData,
    graph,
    canonicalUrl
}: ArticleSchemaParams): WithContext<Article> => {
    const authorId =
        typeof articleData.author === "object" && articleData.author !== null
            ? (articleData.author as { "@id"?: string })["@id"]
            : undefined;

    const person = graph.find(
        (item: unknown): item is { "@type": string; "@id": string; name?: string } =>
            typeof item === "object" &&
            item !== null &&
            (item as Record<string, unknown>)["@type"] === "Person" &&
            (item as Record<string, unknown>)["@id"] === authorId
    );

    const authorName = person?.name ?? "Likvi";

    return {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: articleData.headline,
        name: articleData.name,
        image: articleData.image as ImageObject | string,
        author: {
            "@type": "Person",
            name: authorName
        },
        publisher: organizationSchema,
        datePublished: articleData.datePublished,
        dateModified: articleData.dateModified,
        mainEntityOfPage: canonicalUrl,
        isPartOf: canonicalUrl,
        inLanguage: articleData.inLanguage || "ru-RU"
    };
};